"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
exports.__esModule = true;
var DOMScript_1 = require("@/scripts/utils/DOMScript");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var internal_compatibility_1 = require("rxjs/internal-compatibility");
var API_URL = twGlobal.APIEndpoint;
var FaqsLikeDislike = /** @class */ (function () {
    function FaqsLikeDislike() {
    }
    FaqsLikeDislike.prototype.onLoadEach = function ($element) {
        var _this = this;
        var _a = $element.dataset.id, id = _a === void 0 ? "" : _a;
        var voted = this.getCookie(id);
        var setVote = function (action) {
            var _a;
            (_a = $element.$("[data-action=\"".concat(action, "\"]"))) === null || _a === void 0 ? void 0 : _a.classList.add("--active");
            $element.setAttribute("data-voted", "yes");
            _this.setCookie(id, action);
        };
        if (voted) {
            setVote(voted);
            return;
        }
        var $actionsBtn = $element.$$(".FaqsLikeDislike__action");
        var untilRefresh = (0, DOMScript_1.makeUntilRefresh)();
        untilRefresh((0, rxjs_1.fromEvent)($actionsBtn, "click"))
            .pipe((0, operators_1.map)(function (e) { return e.currentTarget.dataset.action; }), (0, operators_1.switchMap)(function (action) {
            var query = new URLSearchParams({ action: action, id: id }).toString();
            return (0, internal_compatibility_1.ajaxGetJSON)("".concat(API_URL, "tw/v1/like-dislike-faqs/?").concat(query));
        }), (0, operators_1.catchError)(function (_) { return (0, rxjs_1.of)({ response: { html: "" } }); }))
            .subscribe(function (_a) {
            var _b = _a === void 0 ? {} : _a, response = _b.response;
            var _c = response.html, html = _c === void 0 ? "" : _c, _d = response.parameters, parameters = _d === void 0 ? { action: "" } : _d;
            if (html !== "Yeah" || parameters.action == "")
                return;
            setVote(parameters.action);
        });
    };
    FaqsLikeDislike.prototype.setCookie = function ($post_id, $action) {
        var d = new Date();
        d.setTime(d.getTime() + 1 * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie =
            "vote_" + $post_id + "=" + $action + ";" + expires + ";path=/";
    };
    FaqsLikeDislike.prototype.getCookie = function ($post_id) {
        var name = "vote_" + $post_id + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return false;
    };
    FaqsLikeDislike = __decorate([
        (0, DOMScript_1.DOMBlock)({
            selector: ".FaqsLikeDislike",
            isElementArray: true
        })
    ], FaqsLikeDislike);
    return FaqsLikeDislike;
}());
new FaqsLikeDislike();
